<template>
  <div class="modal d-flex flex-column ai-center jc-center">
    <div class="modal-content d-flex ai-center jc-center">
      <div class="content">
        <img src="../../assets/pc/modal-img.png" />
        <div class="desc1">{{ homeLang.modal.desc1 }}</div>
        <div class="desc2">
          {{ homeLang.modal.desc2 }}
        </div>
        <a
          :href="homeLang.foot.media.tgUrl"
          @click="$emit('close')"
          target="_blank"
          class="button"
        >
          {{ homeLang.modal.desc3 }}
        </a>
      </div>
      <img
        class="close"
        src="../../assets/close-modal.png"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homeLang: {
      type: Object,
    },
  },
}
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  z-index: 9998;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-content {
    position: relative;
    background: #fff;
    width: 4.4rem;
    border-radius: 0.08rem;
    .content {
      border-radius: 0.08rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0.06rem;
      padding: 0.32rem 0.32rem 0.36rem;
      background: linear-gradient(180deg, #e8f4ff, rgba(255, 255, 255, 0) 100%);
      img {
        width: 1.71rem;
        height: 0.97rem;
      }
      .desc1 {
        margin: 0.25rem 0 0.08rem;
        font-size: 0.24rem;
        font-family: MiSans, MiSans-Demibold;
        font-weight: 700;
        text-align: center;
        color: #eb5757;
      }
      .desc2 {
        font-size: 0.14rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #828282;
      }
      .button {
        margin-top: 0.4rem;
        padding: 0.16rem 0.76rem;
        background: #2980fe;
        border-radius: 0.08rem;
        font-size: 0.14rem;
        font-family: MiSans, MiSans-Regular;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .close {
      position: absolute;
      top: 0.16rem;
      right: 0.16rem;
      width: 0.2rem;
      height: 0.2rem;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 767px) {
  .modal {
    .modal-content {
      width: 75%;
      border-radius: 0.16rem;
      .content {
        border-radius: 0.16rem;
        img {
          width: 2.39rem;
          height: 1.47rem;
        }
        .desc1 {
          font-size: 0.32rem;
        }
        .desc2 {
          font-size: 0.28rem;
        }
        .button {
          font-size: 0.3rem;
        }
      }
      .close {
        width: 0.28rem;
        height: 0.28rem;
      }
    }
  }
}
</style>